import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc ActionWidgetActivity defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { ActionWidgetActivityService } from 'services/actionWidgetActivity';
 *
 * // create service instance and send/cancel request
 * const actionWidgetActivityService = new ActionWidgetActivityService();
 * const result = await actionWidgetActivityService.fetchData( '<user-id>' ); // fetch data
 * actionWidgetActivityService.cancel(); // cancel an active request
 */
export class ActionWidgetActivityService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    items: get( response, 'body.component.data.state.items', {} ),
                    widget: get( response, 'body.component.structure.widgetConfig', [] )
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
